import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=4778ef28&scoped=true"
import script from "./debug.vue?vue&type=script&lang=js"
export * from "./debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778ef28",
  null
  
)

export default component.exports